module.exports = __webpack_public_path__ + "media/images/menu/capricorn-498ef2a96476deb8d9096df3ea581179.jpg";